/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type InfiniteScrollMessages_patientRefetchableVariables = {
    count?: number | null | undefined;
    cursor?: string | null | undefined;
    id: string;
};
export type InfiniteScrollMessages_patientRefetchableResponse = {
    readonly node: {
        readonly " $fragmentRefs": FragmentRefs<"InfiniteScrollMessages_Patient">;
    } | null;
};
export type InfiniteScrollMessages_patientRefetchable = {
    readonly response: InfiniteScrollMessages_patientRefetchableResponse;
    readonly variables: InfiniteScrollMessages_patientRefetchableVariables;
};



/*
query InfiniteScrollMessages_patientRefetchable(
  $count: Int = 25
  $cursor: String
  $id: ID!
) {
  node(id: $id) {
    __typename
    ...InfiniteScrollMessages_Patient_1G22uz
    id
  }
}

fragment AvatarNode_Node on Node {
  __isNode: __typename
  __typename
  ... on Group {
    groupName: name
  }
  ... on Patient {
    name
    oid_avatar
    isOnline
  }
  ... on Provider {
    name
    oid_avatar
    isOnline
  }
  ... on User {
    name
    oid_avatar
    isOnline
  }
  ... on ChatActivity {
    patient {
      name
      oid_avatar
      isOnline
      id
    }
  }
}

fragment ChatMessageTyping_Node on Node {
  __isNode: __typename
  ... on Patient {
    _id
  }
  ... on Provider {
    _id
  }
  ... on User {
    _id
  }
  ...AvatarNode_Node
}

fragment ChatMessage_Message on Message {
  automated
  createdAt
  oid_file
  ref
  text
  type
  visibility
  mentions {
    mention
  }
  createdBy(includeDeleted: true) {
    name
    ...AvatarNode_Node
    id
  }
  patient(includeDeleted: true) {
    name
    ...AvatarNode_Node
    id
  }
  ...TypographyMessageDetails_Message
}

fragment InfiniteScrollMessages_Patient_1G22uz on Patient {
  id
  _id
  ...ChatMessageTyping_Node
  name
  firstname
  lastname
  master
  avatar: oid_avatar
  messagesConnection(first: $count, after: $cursor, filter: {_operators: {visibility: {in: [public, internal]}, status: {ne: skipped}}}) {
    edges {
      node {
        _id
        oid_patient
        text
        type
        channel
        key
        externalId {
          value
        }
        externalStatus {
          reason
        }
        retry {
          originalMessage
          count
        }
        oid_facility
        oid_createdBy
        oid_recipient
        ...ChatMessage_Message
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment TypographyMessageDetails_Message on Message {
  channel
  createdAt
  ref
  secure
  type
  visibility
  to
  facility {
    _id
    name
    id
  }
  media {
    url
  }
  retry {
    count
  }
  notifyTo {
    channel
    to
  }
  status
  externalStatus {
    reason
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": 25,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "_operators": {
        "status": {
          "ne": "skipped"
        },
        "visibility": {
          "in": [
            "public",
            "internal"
          ]
        }
      }
    }
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "channel",
  "storageKey": null
},
v8 = [
  {
    "kind": "Literal",
    "name": "includeDeleted",
    "value": true
  }
],
v9 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "groupName",
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Group",
  "abstractKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oid_avatar",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOnline",
  "storageKey": null
},
v12 = [
  (v10/*: any*/),
  (v11/*: any*/)
],
v13 = {
  "kind": "InlineFragment",
  "selections": (v12/*: any*/),
  "type": "Patient",
  "abstractKey": null
},
v14 = {
  "kind": "InlineFragment",
  "selections": (v12/*: any*/),
  "type": "Provider",
  "abstractKey": null
},
v15 = {
  "kind": "InlineFragment",
  "selections": (v12/*: any*/),
  "type": "User",
  "abstractKey": null
},
v16 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Patient",
      "kind": "LinkedField",
      "name": "patient",
      "plural": false,
      "selections": [
        (v5/*: any*/),
        (v10/*: any*/),
        (v11/*: any*/),
        (v3/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "ChatActivity",
  "abstractKey": null
},
v17 = [
  (v5/*: any*/),
  (v3/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v2/*: any*/),
      (v9/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/)
    ],
    "type": "Node",
    "abstractKey": "__isNode"
  }
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "to",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InfiniteScrollMessages_patientRefetchable",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count"
              },
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor"
              }
            ],
            "kind": "FragmentSpread",
            "name": "InfiniteScrollMessages_Patient"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InfiniteScrollMessages_patientRefetchable",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstname",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastname",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "master",
                "storageKey": null
              },
              {
                "alias": "avatar",
                "args": null,
                "kind": "ScalarField",
                "name": "oid_avatar",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v6/*: any*/),
                "concreteType": "MessageConnection",
                "kind": "LinkedField",
                "name": "messagesConnection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MessageEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Message",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "oid_patient",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "text",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          },
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "key",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MessageExternalId",
                            "kind": "LinkedField",
                            "name": "externalId",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "value",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MessageExternalStatus",
                            "kind": "LinkedField",
                            "name": "externalStatus",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "reason",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MessageRetry",
                            "kind": "LinkedField",
                            "name": "retry",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "originalMessage",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "count",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "oid_facility",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "oid_createdBy",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "oid_recipient",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "automated",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "oid_file",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ref",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "visibility",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MessageMentions",
                            "kind": "LinkedField",
                            "name": "mentions",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "mention",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v8/*: any*/),
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "createdBy",
                            "plural": false,
                            "selections": (v17/*: any*/),
                            "storageKey": "createdBy(includeDeleted:true)"
                          },
                          {
                            "alias": null,
                            "args": (v8/*: any*/),
                            "concreteType": "Patient",
                            "kind": "LinkedField",
                            "name": "patient",
                            "plural": false,
                            "selections": (v17/*: any*/),
                            "storageKey": "patient(includeDeleted:true)"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "secure",
                            "storageKey": null
                          },
                          (v18/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Facility",
                            "kind": "LinkedField",
                            "name": "facility",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v5/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MessageMedia",
                            "kind": "LinkedField",
                            "name": "media",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "url",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MessageNotifyTo",
                            "kind": "LinkedField",
                            "name": "notifyTo",
                            "plural": true,
                            "selections": [
                              (v7/*: any*/),
                              (v18/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v6/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "InfiniteScrollMessages_messagesConnection",
                "kind": "LinkedHandle",
                "name": "messagesConnection"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v9/*: any*/),
                  (v16/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "type": "Patient",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7649896b920b6f6012fc1171daebf021",
    "id": null,
    "metadata": {},
    "name": "InfiniteScrollMessages_patientRefetchable",
    "operationKind": "query",
    "text": "query InfiniteScrollMessages_patientRefetchable(\n  $count: Int = 25\n  $cursor: String\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...InfiniteScrollMessages_Patient_1G22uz\n    id\n  }\n}\n\nfragment AvatarNode_Node on Node {\n  __isNode: __typename\n  __typename\n  ... on Group {\n    groupName: name\n  }\n  ... on Patient {\n    name\n    oid_avatar\n    isOnline\n  }\n  ... on Provider {\n    name\n    oid_avatar\n    isOnline\n  }\n  ... on User {\n    name\n    oid_avatar\n    isOnline\n  }\n  ... on ChatActivity {\n    patient {\n      name\n      oid_avatar\n      isOnline\n      id\n    }\n  }\n}\n\nfragment ChatMessageTyping_Node on Node {\n  __isNode: __typename\n  ... on Patient {\n    _id\n  }\n  ... on Provider {\n    _id\n  }\n  ... on User {\n    _id\n  }\n  ...AvatarNode_Node\n}\n\nfragment ChatMessage_Message on Message {\n  automated\n  createdAt\n  oid_file\n  ref\n  text\n  type\n  visibility\n  mentions {\n    mention\n  }\n  createdBy(includeDeleted: true) {\n    name\n    ...AvatarNode_Node\n    id\n  }\n  patient(includeDeleted: true) {\n    name\n    ...AvatarNode_Node\n    id\n  }\n  ...TypographyMessageDetails_Message\n}\n\nfragment InfiniteScrollMessages_Patient_1G22uz on Patient {\n  id\n  _id\n  ...ChatMessageTyping_Node\n  name\n  firstname\n  lastname\n  master\n  avatar: oid_avatar\n  messagesConnection(first: $count, after: $cursor, filter: {_operators: {visibility: {in: [public, internal]}, status: {ne: skipped}}}) {\n    edges {\n      node {\n        _id\n        oid_patient\n        text\n        type\n        channel\n        key\n        externalId {\n          value\n        }\n        externalStatus {\n          reason\n        }\n        retry {\n          originalMessage\n          count\n        }\n        oid_facility\n        oid_createdBy\n        oid_recipient\n        ...ChatMessage_Message\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment TypographyMessageDetails_Message on Message {\n  channel\n  createdAt\n  ref\n  secure\n  type\n  visibility\n  to\n  facility {\n    _id\n    name\n    id\n  }\n  media {\n    url\n  }\n  retry {\n    count\n  }\n  notifyTo {\n    channel\n    to\n  }\n  status\n  externalStatus {\n    reason\n  }\n}\n"
  }
};
})();
(node as any).hash = 'ee37a50939763bec7bf5214a581cd155';
export default node;
